module.exports = __webpack_public_path__ + "static/Testimonial_Thomas_Schoeppe-2e9a8ba01a02abbd3560c732128b2c75.png";